// @ts-check
import React from 'react';
import { Box, useTheme, Title } from '../../../pdf-design-system';
import useRoom from '../useRoom';
import VieVinumLogo from '../VieVinumLogo';
// @ts-ignore Images are not allowed currently.
// import roomCover from '../Stencil/vievinum-room-cover.png';

export default function RoomCover() {
  const room = useRoom();
  const { theme } = useTheme();
  return (
    <Box
      style={{
        display: 'flex',
        marginHorizontal: '-12mm',
        marginVertical: '-11mm',
        height: '100%',
      }}
    >
      <Box
        style={{
          backgroundColor: theme.colors.primary,
          color: theme.colors.onPrimary,
          paddingLeft: '18mm',
          paddingRight: '12mm',
          paddingTop: '11mm',
          paddingBottom: '3mm',
          textAlign: 'right',
          height: '178mm',
        }}
      >
        <VieVinumLogo
          color={theme.colors.onPrimary}
          style={{ width: '34.5mm', height: '23mm', marginLeft: 'auto' }}
        />
        <Title variant="largest" style={{ marginTop: 'auto' }}>
          {room?.name}
        </Title>
      </Box>
      <Box
        style={{
          color: theme.colors.primary,
          paddingLeft: '18mm',
          paddingRight: '12mm',
          paddingTop: '3mm',
          paddingBottom: '11mm',
          textAlign: 'right',
        }}
      >
        <Title variant="medium">{room?.subtitle}</Title>
      </Box>
      {/* <Stencil
        src={roomCover}
        style={{ height: '234mm', top: '3mm', left: '3mm', width: '162mm' }}
      /> */}
    </Box>
  );
}
